"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useT = exports.useLocalization = void 0;
const react_1 = require("react");
const context_1 = require("./context");
const helpers_1 = require("./helpers");
const useLocalization = () => (0, react_1.useContext)(context_1.LocalizationContext);
exports.useLocalization = useLocalization;
/**
 * Hook to get text resources.
 * @param {TextResources} selector
 */
function useT(selector) {
    const context = (0, react_1.useContext)(context_1.LocalizationContext);
    return (0, helpers_1.getTextResourceShared)(context, selector);
}
exports.useT = useT;
//# sourceMappingURL=hooks.js.map